<div class="row align-items-end">
    <div class="form-group col-2">
    </div>
    <div class="form-group custom-control custom-switch col-3">
        <input type="checkbox" class="custom-control-input" id="testModelSwitch" name="testModelSwitch" ngModel #testModelSwitch
            (change)="onChangeTestModel()">
        <label class="custom-control-label" for="testModelSwitch">
            Test Model ({{testModelSwitchRef.nativeElement.checked ? 'True' : 'False'}})
        </label>
    </div>
    <div class="form-group custom-control custom-switch col-3">
        <input type="checkbox" class="custom-control-input" id="useDeploymentIdSwitch" name="useDeploymentIdSwitch" ngModel #useDeploymentIdSwitch
            (change)="onChangeUseDeploymentId()">
        <label class="custom-control-label" for="useDeploymentIdSwitch">
            Use Deployment Id ({{useDeploymentIdSwitchRef.nativeElement.checked ? 'True' : 'False'}})
        </label>
    </div>
    <div class="form-group custom-control custom-switch col-3">
        <input type="checkbox" class="custom-control-input" id="byOwnerSwitch" name="byOwnerSwitch" ngModel #byOwnerSwitch
            (change)="onChangeByOwner()">
        <label class="custom-control-label" for="byOwnerSwitch">
            By Owner ({{byOwnerSwitchRef.nativeElement.checked ? 'True' : 'False'}})
        </label>
    </div>
    <div class="form-group col-6" [formGroup]="dataRobotModelForm">
        <label for="description" class="col-form-label">Description:</label>
        <input id="description" type="text" class="form-control" formControlName="description"
            name="description" on-focusout="onChangeDescriptionValue()">
    </div>
    <div class="form-group col-6" [formGroup]="dataRobotModelForm">
        <label for="deploymentId" class="col-form-label">Deployment Id:</label>
        <input id="deploymentId" type="text" class="form-control" formControlName="deploymentId"
            name="deploymentId" on-focusout="onChangeDeploymentIdValue()">
    </div>
    <div class="form-group col-6" [formGroup]="dataRobotModelForm">
        <label for="projectToken" class="col-form-label">Project Token:</label>
        <input id="projectToken" type="text" class="form-control" formControlName="projectToken"
            name="projectToken" on-focusout="onChangeProjectTokenValue()">
    </div>    
    <div class="form-group col-6" [formGroup]="dataRobotModelForm">
        <label for="modelToken" class="col-form-label">Model Token:</label>
        <input id="modelToken" type="text" class="form-control" formControlName="modelToken"
            name="modelToken" on-focusout="onChangeModelTokenValue()">
    </div>
    <div class="form-group col-6" [formGroup]="dataRobotModelForm">
        <label for="modelAffix" class="col-form-label">Model Affix:</label>
        <input id="modelAffix" type="text" class="form-control" formControlName="modelAffix"
            name="modelAffix" on-focusout="onChangeModelAffix()">
    </div>
</div>